import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import 'components/tenant_app/AppPage.css';
import 'components/landlord_app/dashboard/dashboard.css';
import 'react-table/react-table.css';
import { browserHistory } from 'react-router';

import { BounceLoader } from 'halogenium';

import classNames from 'classnames';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import DuplicateTenantDrawer from './DuplicateTenantDrawer';
import DuplicateTenantsCard from './DuplicateTenantsCard';
import MobileDuplicateTenantCard from './MobileDuplicateTenantCard';
import MediaQuery from 'react-responsive';

import Drawer from 'components/ui/Drawer';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import { featureEnabled } from 'helpers/ToggleBot';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, YAxis } from 'recharts';

import {
  getData,
  getGraphData,
  updateDuplicateTenant,
  getDuplicateTenants,
} from 'actions/landlordDashboardActions';

import { hostIsBoardwalk, hostIsCapreit, hostIsConcert } from 'helpers/CurrentWindowLocation';
import { AccentColor } from 'helpers/AccentColorHelper';
import { toFriendlyDateString } from 'helpers/Formatter';
import { localize } from 'react-localize-redux';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '15px',
  },
  duplicateTenantsCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '18px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '15px',
    marginBottom: '10px',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
};

const ConnectedLandlordDashboard = connect(
  store => {
    return {
      data: store.landlordDashboard.data,
      graphData: store.landlordDashboard.graphData,
      duplicateTenants: store.landlordDashboard.duplicateTenants,
      showPage: store.authentication.showPage,
      userFirstName: store.landlordDashboard.data.user_first_name,
      multiFamilyEnabled: store.userTypes.multiFamilyEnabled,
      languageCode: store.locale.currentLanguage,
      showMessaging: store.userTypes.showMessaging,
      userPermissions: store.userTypes.permissions,
      admin: store.userTypes.admin,
    };
  },
  { getGraphData, getData, updateDuplicateTenant, getDuplicateTenants }
)(
  class LandlordDashboard extends Component {
    constructor(props) {
      super(props);
      this.state = {
        graphData: {},
        duplicateDrawerOpen: false,
        duplicateTenant: {},
        originalTenant: {},
        merge: false,
      };
    }

    componentDidMount() {
      this.props.getData();
      this.props.getGraphData().then(() => {
        let dataClone = JSON.parse(JSON.stringify(this.props.graphData));
        const dataKeys = [
          'amenity_bookings',
          'applications',
          'open_tickets',
          'parcels',
          'showings',
          'tickets',
        ];
        dataKeys.forEach(key => {
          dataClone[key].forEach(item => {
            item['name'] = toFriendlyDateString(new Date(item['name']), {
              language: this.props.languageCode,
            });
          });
        });
        this.setState({
          graphData: dataClone,
        });
      });
      this.props.getDuplicateTenants();
    }

    evaluateWelcomeText = () => {
      const { translate, userFirstName } = this.props;
      const currentHour = new Date().getHours();
      let translationKey = 'landlordPortal.dashboard.welcomeBack';
      if (currentHour >= 6 && currentHour <= 12) {
        translationKey = 'landlordPortal.dashboard.goodMorning';
      } else if (currentHour <= 17) {
        translationKey = 'landlordPortal.dashboard.goodAfternoon';
      } else if (currentHour < 19) {
        translationKey = 'landlordPortal.dashboard.goodEvening';
      }

      if (userFirstName) {
        return translate(translationKey).props.children + ' ' + userFirstName;
      } else {
        return translate(translationKey).props.children;
      }
    };

    viewModifyDuplicate = (duplicateTenant, originalTenant = {}) => {
      this.setState({
        duplicateDrawerOpen: true,
        duplicateTenant: duplicateTenant,
        originalTenant: originalTenant,
        merge: false,
      });
    };

    mergeDuplicate = (duplicateTenant, originalTenant = {}) => {
      this.setState({
        duplicateDrawerOpen: true,
        duplicateTenant: duplicateTenant,
        originalTenant: originalTenant,
        merge: true,
      });
    };

    render() {
      return (
        <div className="body" role="main">
          <div className="centers">
            <div className="row">
              {this._renderWelcomeMessage()}
              {this._renderActionInsights()}
            </div>
            {this._renderDuplicateTenants()}
            {this._renderDuplicateDrawer()}
            {this._renderGraphsLoading()}
            {this._renderGraphsLoaded()}
          </div>
        </div>
      );
    }

    _renderActionInsights = () => {
      const { translate, userPermissions } = this.props;

      return (
        <div className="row" style={{ paddingBottom: '5px' }}>
          {this._renderShowingsAndApplicationsTiles()}
          {this._renderAdditionalMaintenanceTiles()}

          {userPermissions.maintenance &&
            this.renderDashboardOverviewTile(
              this.props.data.tickets,
              translate('landlordPortal.dashboard.openTickets'),
              () => browserHistory.push('/companies/maintenance/tickets')
            )}

          {this._renderUnreadMessagesTitle()}
        </div>
      );
    };

    _renderUnreadMessagesTitle = () => {
      const { translate, showMessaging, userPermissions } = this.props;

      if (hostIsCapreit() || !showMessaging || !userPermissions.messaging) return;

      return this.renderDashboardOverviewTile(
        this.props.data.unread_messages,
        translate('landlordPortal.dashboard.unreadMessages'),
        () => browserHistory.push('/companies/messaging')
      );
    };

    _renderAdditionalMaintenanceTiles = () => {
      if (!hostIsConcert() && !hostIsCapreit()) return;
      if (!this.props.userPermissions.maintenance) return;
      const { translate } = this.props;
      return (
        <Fragment>
          {this.renderDashboardOverviewTile(
            this.props.data.new_tickets,
            translate('landlordPortal.dashboard.newTickets'),
            () => browserHistory.push('/companies/maintenance/tickets?filter_value=new')
          )}

          {this.renderDashboardOverviewTile(
            this.props.data.urgent_tickets,
            translate('landlordPortal.dashboard.urgentTickets'),
            () => browserHistory.push('/companies/maintenance/tickets?filter_value=emergency')
          )}
        </Fragment>
      );
    };

    _renderShowingsAndApplicationsTiles = () => {
      if (!this.props.multiFamilyEnabled) return;
      if (hostIsCapreit()) return;
      if (hostIsBoardwalk()) return;
      const { translate } = this.props;

      return (
        <Fragment>
          {this.renderDashboardOverviewTile(
            this.props.data.showings,
            translate('landlordPortal.dashboard.showings'),
            () => browserHistory.push('/companies/showings')
          )}

          {this.renderDashboardOverviewTile(
            this.props.data.applications,
            translate('landlordPortal.dashboard.applications'),
            () => browserHistory.push('/companies/applications')
          )}
        </Fragment>
      );
    };

    _renderGraphsLoading = () => {
      if (this.state.graphData) return;
      const { translate } = this.props;

      return (
        <div className="row" style={{ textAlign: 'center', marginTop: '20%' }}>
          <div
            style={{
              textAlign: 'center',
              width: '60px',
              margin: 'auto',
            }}
          >
            <BounceLoader color={AccentColor()} />
          </div>
          <p>{translate('landlordPortal.dashboard.bearWithUs')}</p>
        </div>
      );
    };

    _renderGraphsLoaded = () => {
      if (!this.state.graphData) return;

      return (
        <Fragment>
          {this._renderShowingsAndApplications()}
          {this._renderMaintenanceTickets()}
          {this._renderParcelsAndAmenities()}
          <div style={{ height: '50px' }} />
        </Fragment>
      );
    };

    _renderMaintenanceTickets = () => {
      if (!this.props.userPermissions.maintenance) return;
      if (!this.state.graphData.has_tickets) return;
      const { translate } = this.props;
      return (
        <div className="row">
          <div className="col-sm-6" style={{ padding: '15px' }}>
            <Card style={style.transactionCard}>
              <CardText expandable={true} style={{ padding: '0 0 10px' }}>
                <h4 style={{ padding: '0 15px', marginBottom: '20px' }}>
                  {translate('landlordPortal.dashboard.tickets')}
                </h4>
                <ResponsiveContainer height={200}>
                  <BarChart
                    width={600}
                    height={300}
                    data={this.state.graphData.tickets}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                      dataKey="tickets"
                      fill="#477be8"
                      name={translate('landlordPortal.dashboard.tickets').props.children}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </CardText>
            </Card>
          </div>
          <div className="col-sm-6" style={{ padding: '15px' }}>
            <Card style={style.transactionCard}>
              <CardText expandable={true} style={{ padding: '0 0 10px' }}>
                <h4 style={{ padding: '0 15px', marginBottom: '20px' }}>
                  {translate('landlordPortal.dashboard.ticketsOpenVsClosed')}
                </h4>
                <ResponsiveContainer height={200}>
                  <BarChart
                    width={600}
                    height={300}
                    data={this.state.graphData.open_tickets}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                      dataKey="opened"
                      fill="#477be8"
                      name={translate('landlordPortal.dashboard.opened').props.children}
                    />
                    <Bar
                      dataKey="closed"
                      fill="#477be8c7"
                      name={translate('landlordPortal.dashboard.closed').props.children}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </CardText>
            </Card>
          </div>
        </div>
      );
    };

    _renderParcelsAndAmenities = () => {
      if (!this.state.graphData.has_amenities_or_parcels) return;
      const { translate } = this.props;
      return (
        <div className="row">
          <div className="col-sm-6" style={{ padding: '15px' }}>
            <Card style={style.transactionCard}>
              <CardText expandable={true} style={{ padding: '0 0 10px' }}>
                <h4 style={{ padding: '0 15px', marginBottom: '20px' }}>
                  {translate('landlordPortal.dashboard.amenityBookings')}
                </h4>
                <ResponsiveContainer height={200}>
                  <BarChart
                    width={600}
                    height={300}
                    data={this.state.graphData.amenity_bookings}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                      dataKey="bookings"
                      fill="#477be8"
                      name={translate('landlordPortal.dashboard.amenityBookings').props.children}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </CardText>
            </Card>
          </div>
          {this._renderParcelsGraph()}
        </div>
      );
    };

    _renderParcelsGraph = () => {
      if (hostIsCapreit()) return;
      const { translate } = this.props;

      return (
        <div className="col-sm-6" style={{ padding: '15px' }}>
          <Card style={style.transactionCard}>
            <CardText expandable={true} style={{ padding: '0 0 10px' }}>
              <h4 style={{ padding: '0 15px', marginBottom: '20px' }}>
                {translate('landlordPortal.dashboard.parcels')}
              </h4>
              <ResponsiveContainer height={200}>
                <BarChart
                  width={600}
                  height={300}
                  data={this.state.graphData.parcels}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar
                    dataKey="received"
                    fill="#477be8"
                    name={translate('landlordPortal.dashboard.received').props.children}
                  />
                  <Bar
                    dataKey="released"
                    fill="#477be8c7"
                    name={translate('landlordPortal.dashboard.released').props.children}
                  />
                </BarChart>
              </ResponsiveContainer>
            </CardText>
          </Card>
        </div>
      );
    };

    _renderShowingsAndApplications = () => {
      if (!this.state.graphData.has_applications_or_showings) return;
      if (hostIsCapreit()) return;
      if (hostIsBoardwalk()) return;
      const { translate } = this.props;

      return (
        <div className="row">
          <div className="col-sm-6" style={{ padding: '15px' }}>
            <Card style={style.transactionCard}>
              <CardText expandable={true} style={{ padding: '0 0 10px' }}>
                <h4 style={{ padding: '0 15px', marginBottom: '20px' }}>
                  {translate('landlordPortal.dashboard.showings')}
                </h4>
                <ResponsiveContainer height={200}>
                  <BarChart
                    width={600}
                    height={300}
                    data={this.state.graphData.showings}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                      dataKey="showings"
                      fill="#477be8"
                      name={translate('landlordPortal.dashboard.showings').props.children}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </CardText>
            </Card>
          </div>
          <div className="col-sm-6" style={{ padding: '15px' }}>
            <Card style={style.transactionCard}>
              <CardText expandable={true} style={{ padding: '0 0 10px' }}>
                <h4 style={{ padding: '0 15px', marginBottom: '20px' }}>
                  {translate('landlordPortal.dashboard.applications')}
                </h4>
                <ResponsiveContainer height={200}>
                  <BarChart
                    width={600}
                    height={300}
                    data={this.state.graphData.applications}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                      dataKey="applications"
                      fill="#477be8"
                      applications={
                        translate('landlordPortal.dashboard.applications').props.children
                      }
                    />
                  </BarChart>
                </ResponsiveContainer>
              </CardText>
            </Card>
          </div>
        </div>
      );
    };

    _renderWelcomeMessage = () => {
      return <HeaderWithPeriod headerText={this.evaluateWelcomeText()} />;
    };

    renderDashboardOverviewTile = (overviewHighlight, itemDescription, onClickAction) => (
      <div
        className="col-sm-3 col-xs-6"
        style={{ textAlign: 'center', margin: '10px 0', padding: '0 15px' }}
        onClick={onClickAction}
      >
        <Card
          style={{ ...style.transactionCard, padding: 0 }}
          className={classNames('highlight-on-hover')}
        >
          <CardText expandable={true} style={{ padding: '15px', cursor: 'pointer' }}>
            <h3 style={{ margin: 0, fontSize: '30px' }}>{overviewHighlight}</h3>
            <hr
              style={{
                maxWidth: '35px',
                margin: '12px auto',
                borderTop: `3px solid ${AccentColor()}`,
              }}
            />
            <p style={{ fontFamily: 'Circular', margin: 0 }}>{itemDescription}</p>
          </CardText>
        </Card>
      </div>
    );

    _renderDuplicateTenants = () => {
      const adminBwalk = hostIsBoardwalk() && this.props.admin === true;

      if (!featureEnabled('ui.dashboard.duplicate_leads') && !adminBwalk) return;
      if ((this.props.duplicateTenants || []).length === 0) return null;
      const { translate } = this.props;

      return (
        <div>
          <div className="row">
            <div className="col-sm-12" style={{ padding: '15px' }}>
              <h4 style={{ padding: '0 10px', marginBottom: '10px', color: 'black' }}>
                {translate('landlordPortal.dashboard.duplicateResidents')}(
                {this.props.duplicateTenants.length})
              </h4>{' '}
              <div style={{ paddingLeft: '10px', marginBottom: '10px' }}>
                {translate('landlordPortal.dashboard.itLooksLike')}{' '}
              </div>
            </div>
          </div>
          <div className="row">
            <MediaQuery query="(min-device-width: 750px)">
              {(this.props.duplicateTenants || []).map((record, index) => (
                <DuplicateTenantsCard
                  key={`duplicate_tenant_${index}`}
                  record={record}
                  viewModify={this.viewModifyDuplicate}
                  mergeDuplicate={this.mergeDuplicate}
                />
              ))}
            </MediaQuery>
            <MediaQuery query="(max-device-width: 750px)">
              {(this.props.duplicateTenants || []).map((record, index) => (
                <MobileDuplicateTenantCard
                  key={`duplicate_tenant_${index}`}
                  record={record}
                  viewModify={this.viewModifyDuplicate}
                  mergeDuplicate={this.mergeDuplicate}
                />
              ))}
            </MediaQuery>
          </div>
        </div>
      );
    };

    _renderDuplicateDrawer = () => {
      const adminBwalk = hostIsBoardwalk() && this.props.admin === true;

      if (!featureEnabled('ui.dashboard.duplicate_leads') && !adminBwalk) return;
      if (!this.state.duplicateDrawerOpen) return null;
      return (
        <Drawer
          visible={this.state.duplicateDrawerOpen}
          onClose={() =>
            this.setState({ duplicateDrawerOpen: false, duplicateTenant: null, merge: false })}
          closable={false}
          width={550}
        >
          <DuplicateTenantDrawer
            handleClose={() =>
              this.setState({ duplicateDrawerOpen: false, duplicateTenant: null, merge: false })}
            duplicateTenant={this.state.duplicateTenant}
            originalTenant={this.state.originalTenant}
            updateDuplicateTenant={this.props.updateDuplicateTenant}
            merge={this.state.merge}
          />
        </Drawer>
      );
    };
  }
);

export default localize()(ConnectedLandlordDashboard);
